import { OtherWaysToContactCarrotTile } from "#/components/care-team/OtherWaysToContactCarrotTile"
import React from "react"
import { BookAgainExpertBio, BookAgainPageLayout } from "#/components/care-team/BookAgainPageLayout"
import { RootBreadcrumb } from "#/components/talk-to-carrot/util/talkToCarrotMolecules"
import { Breadcrumb, Breadcrumbs, Grid, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { Redirect, useLocation } from "react-router-dom"
import { useHistory } from "react-router"
import { ExpertBioModal } from "#/components/expert-bios/expert-bio-modal"
import { CareTeamExpertWithTiles, shouldSkipServiceSelection } from "#/components/care-team/utils/careTeamUtil"
import { Tile } from "#/lib/contentful/components/TileElement"
import slugify from "slugify"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { MemberActions } from "#/services/memberActionTracking/memberActions"

const CareTeamTilesWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Grid
      container
      spacing={3}
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(265px, 1fr))",
        gridAutoRows: "1fr",
        gridGap: "24px"
      }}
    >
      {React.Children.map(children, (child, index) => (
        <Grid item key={index}>
          {child}
        </Grid>
      ))}
    </Grid>
  )
}

export const BookAgainWithExpertPage = (): JSX.Element => {
  const history = useHistory()
  const location = useLocation<{ expert: CareTeamExpertWithTiles }>()
  const expert = location.state?.expert
  const { mutate: trackAction } = useMemberActionTracking()

  if (!expert) {
    return <Redirect to="/care-team" />
  }

  const shouldRedirectToSingleService = shouldSkipServiceSelection(expert)

  if (shouldRedirectToSingleService) {
    const slug = expert.services?.[0]?.tileEntry?.slug || slugify(expert.expertBio.name)
    history.push({
      pathname: `/care-team/book-again/${slug}`,
      state: { expert: expert, reasonId: expert.services[0].reasonId }
    })
  }

  return (
    <BookAgainPageLayout
      breadcrumbs={
        <Breadcrumbs>
          <RootBreadcrumb />
          <Breadcrumb currentPage>
            <FormattedMessage
              defaultMessage="Book Again: {specialistName}"
              values={{ specialistName: expert?.expertBio.name }}
            />
          </Breadcrumb>
        </Breadcrumbs>
      }
      content={
        <>
          <Typography variant="h3">
            <FormattedMessage defaultMessage="What would you like to talk about?" />
          </Typography>
          <BookAgainExpertBio expertBio={expert?.expertBio} />
          <ExpertBioModal />
          <CareTeamTilesWrapper>
            {expert?.services?.map((service) => {
              const { tileEntry } = service
              return tileEntry ? (
                <Tile
                  key={tileEntry.id}
                  entryId={tileEntry.id}
                  title={tileEntry.title}
                  description={tileEntry.description}
                  secondaryDescription={tileEntry.secondaryDescription}
                  iconUrl={tileEntry.iconUrl}
                  disabled={false}
                  showArrow={false}
                  onClick={() => {
                    trackAction({
                      memberActionTaken: MemberActions.BOOK_AGAIN_CHAT_TYPE_TILE_CLICKED,
                      metaData: {
                        expert_name: expert.expertBio.name,
                        chat_type: tileEntry.title
                      }
                    })
                    history.push({
                      pathname: `/care-team/book-again/${tileEntry.slug}`,
                      state: { expert, reasonId: service.reasonId || null }
                    })
                  }}
                />
              ) : null
            })}
          </CareTeamTilesWrapper>
        </>
      }
      contactUsCard={<OtherWaysToContactCarrotTile />}
    />
  )
}
